/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ActionStatusEnumType } from "./ActionStatusEnum"
import { RootStoreType } from "./index"


/**
 * DriverActionDtoBase
 * auto generated base class for the model DriverActionDtoModel.
 */
export const DriverActionDtoModelBase = ModelBase
  .named('DriverActionDto')
  .props({
    __typename: types.optional(types.literal("DriverActionDto"), "DriverActionDto"),
    actionUuid: types.identifier,
    name: types.union(types.undefined, types.string),
    projectId: types.union(types.undefined, types.integer),
    userUuid: types.union(types.undefined, types.string),
    input: types.union(types.undefined, types.null, types.string),
    undo: types.union(types.undefined, types.null, types.boolean),
    redo: types.union(types.undefined, types.null, types.boolean),
    status: types.union(types.undefined, ActionStatusEnumType),
    failReason: types.union(types.undefined, types.null, types.string),
    receivedAt: types.union(types.undefined, types.null, types.string),
    createdAt: types.union(types.undefined, types.null, types.string),
    driverUuid: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DriverActionDtoModelSelector extends QueryBuilder {
  get actionUuid() { return this.__attr(`actionUuid`) }
  get name() { return this.__attr(`name`) }
  get projectId() { return this.__attr(`projectId`) }
  get userUuid() { return this.__attr(`userUuid`) }
  get input() { return this.__attr(`input`) }
  get undo() { return this.__attr(`undo`) }
  get redo() { return this.__attr(`redo`) }
  get status() { return this.__attr(`status`) }
  get failReason() { return this.__attr(`failReason`) }
  get receivedAt() { return this.__attr(`receivedAt`) }
  get createdAt() { return this.__attr(`createdAt`) }
  get driverUuid() { return this.__attr(`driverUuid`) }
}
export function selectFromDriverActionDto() {
  return new DriverActionDtoModelSelector()
}

export const driverActionDtoModelPrimitives = selectFromDriverActionDto().actionUuid.name.projectId.userUuid.input.undo.redo.status.failReason.receivedAt.createdAt.driverUuid
